var render = function render(){var _vm=this,_c=_vm._self._c;return _c('export-date-range',{attrs:{"title":"Export Venue Recommendations","export_path":"/v1/export/venue_recommendations/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }